import {FC} from 'react';
import { TextField } from '@material-ui/core';
import { useField } from 'formik';
import { TextFieldProps } from '../../../interfaces';

const TextfieldWrapper:FC<TextFieldProps> = ({
  name,
  label,
  ...otherProps
}) => {
  const [field, mata] = useField(name);

  const configTextfield:any = {
    ...field,
    ...otherProps,
    fullWidth: true,
    variant: 'outlined'
    
  };

  if (mata && mata.touched && mata.error) {
    configTextfield.error = true;
    configTextfield.helperText = mata.error;
  }

  return (
    <>
    <label>{label}</label>
    <TextField {...configTextfield} />
    </>
  );
};

export default TextfieldWrapper;
